import { render, staticRenderFns } from "./ImpresoraVienw.vue?vue&type=template&id=54c7d3a3"
import script from "./ImpresoraVienw.vue?vue&type=script&lang=js"
export * from "./ImpresoraVienw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports